"use client";
/*
 * Documentation:
 * Tag — https://app.subframe.com/ae91faa555e6/library?component=Tag_781d4d8e-702f-4c96-9ea8-28108d6b4152
 */

import React from "react";
import * as SubframeUtils from "../utils";
import * as SubframeCore from "@subframe/core";

interface TagRootProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "no-data" | "empty-status" | "blue" | "selectable" | "info-tag";
  score?: React.ReactNode;
  className?: string;
}

const TagRoot = React.forwardRef<HTMLElement, TagRootProps>(function TagRoot(
  { variant = "no-data", score, className, ...otherProps }: TagRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/781d4d8e flex h-6 items-center gap-1 rounded-full bg-neutral-100 px-2",
        {
          "border border-solid border-neutral-border bg-white active:border-none active:bg-brand-50 focus-within:border focus-within:border-solid focus-within:border-neutral-border focus-within:bg-white":
            variant === "selectable",
          "bg-brand-50": variant === "blue",
          "bg-transparent": variant === "empty-status",
        },
        className
      )}
      ref={ref as any}
      {...otherProps}
    >
      <SubframeCore.Icon
        className={SubframeUtils.twClassNames(
          "text-body font-body text-default-font",
          {
            hidden:
              variant === "info-tag" ||
              variant === "blue" ||
              variant === "empty-status",
            "hidden group-active/781d4d8e:inline-flex group-active/781d4d8e:text-brand-primary group-focus-within/781d4d8e:hidden group-focus-within/781d4d8e:text-default-font":
              variant === "selectable",
          }
        )}
        name="FeatherCheck"
      />
      {score ? (
        <span
          className={SubframeUtils.twClassNames(
            "text-label font-label text-neutral-700",
            {
              "text-label-bold font-label-bold group-active/781d4d8e:text-brand-primary group-focus-within/781d4d8e:text-neutral-700":
                variant === "selectable",
              "text-brand-primary": variant === "blue",
              "text-subtext-color": variant === "empty-status",
            }
          )}
        >
          {score}
        </span>
      ) : null}
    </div>
  );
});

export const Tag = TagRoot;
